import { css } from 'emotion';
import PropTypes from 'prop-types';
import React from 'react';

import Heading from 'site-react/core/Heading';
import VerticalSpacing from 'site-react/core/VerticalSpacing';
import theme from 'site-react/theme';
import { footerLinkStyle } from './Footer.styles';

const footerListStyle = css`
  display: inline-block;
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
  vertical-align: top;
  width: 100%;
`;

const footerListContentWrapperStyle = css`
  display: inline-block;
  text-align: center;
  vertical-align: middle;
`;

const footerListLinkWrapperStyle = css`
  list-style: none;
  padding: 0;
`;

const footerLinkWrapperStyle = css`
  margin-bottom: ${theme.spacing.lg}px;
  padding: 0;
  text-align: inherit;
`;

const footerListLinkStyle = css`
  ${footerLinkStyle};
  color: ${theme.colors.neutral200};
  display: inline;
  font-size: ${theme.font.size.sm};
`;

/**
 * Displays title and list of footer links
 */
const FooterList = ({ title, links }) => {
  return (
    <div className={footerListStyle}>
      <div className={footerListContentWrapperStyle}>
        <Heading color="white" type="title3">
          {title}
        </Heading>
        <VerticalSpacing size="xl" />
        <nav aria-label={title}>
          <ul className={footerListLinkWrapperStyle}>
            {links.map((link) => (
              <li
                key={`${link.label}:${link.url}`}
                className={footerLinkWrapperStyle}
              >
                <a
                  className={footerListLinkStyle}
                  href={link.url}
                  target={link.target && link.target}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

FooterList.defaultProps = {};

FooterList.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      target: PropTypes.string,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  title: PropTypes.string.isRequired,
};
export default FooterList;
